let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c7DhJ")).then(() => parcelRequire('ak2ew'));